import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Alert,
} from 'reactstrap';

import ReactTooltip from 'react-tooltip';

import { FetchData } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';

import { WorkOrderFollowUpForm } from './WorkOrderFollowUpForm';
import { WorkOrderFollowUpTableDefault } from './WorkOrderFollowUpTableDefault';
import { LoadingModal } from './LoadingModal';

const moment = require('moment');

export class WorkOrderFollowUp extends Component {
  static displayName = WorkOrderFollowUp.name;
  constructor(props) {
    super(props);
    this.state = {
      workOrders: [],
      loading: true,
      fetchingData: false,
      modal: false,

      model: this.props.model,
      alert: this.props.alert,
      sortModel: {
        SortBy: 'jobDateTime',
        SortDirection: 'desc',
      },
    };
    //
    this.user = JSON.parse(GetCookie('user'));

    this.setModal = this.setModal.bind(this);
    this.populateFollowUps = this.populateFollowUps.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleJobDoubleClicked = this.handleJobDoubleClicked.bind(this);
  }

  componentDidMount() {
    this.populateFollowUps();
    document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  setModal() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  keydownHandler(e) {
    if (e.keyCode === 27 && this.props.modal && !this.state.modal) {
      // Escape key - close the modal (only if child modal is not open)
      e.preventDefault();
      e.stopPropagation();
      this.props.setModal();
    }
  }

  handleJobDoubleClicked(data) {
    window.open(`${window.location.origin}/?jobid=${data.jobId}`, '_blank');
  }

  populateFollowUps() {
    this.setState({ loading: true, fetchingData: true });

    var model = {
      StartDate: moment(this.state.model.JobDateTime)
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      EndDate: '2100-01-01',
      ClmId: this.state.model.ClmId,
    };
    FetchData('/getworkorders', 'POST', this.user.token, model).then((data) => {
      this.setState({ workOrders: data, loading: false, fetchingData: false });
    });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        modal: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        this.populateFollowUps();
        this.props.handleSaveEventSuccess(alert);
      }
    );
  }

  renderFollowUpTable(workOrders) {
    return (
      <WorkOrderFollowUpTableDefault
        workOrders={workOrders}
        onJobDoubleClicked={this.handleJobDoubleClicked}
      />
    );
  }

  render() {
    let followUpContents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderFollowUpTable(this.state.workOrders)
    );

    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ height: '460px', width: '1280px' }}
          backdrop="static"
        >
          <ModalHeader>Followup Jobs</ModalHeader>
          <ModalBody style={{ height: '500px' }}>
            <Row>
              <Col style={{ textAlign: 'center' }}>
                <Alert
                  color={this.state.alert.color}
                  isOpen={this.state.alert.isOpen}
                >
                  {this.state.alert.message}
                </Alert>
              </Col>
            </Row>

            {/* Show the loading modal if needed */}
            <LoadingModal fetchingData={this.state.fetchingData} />

            <ReactTooltip
              className="tooltip"
              id="rtp"
              place="top"
              type="dark"
              effect="solid"
              html={true}
            />
            <Row>
              <Col>{followUpContents}</Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.setModal}>
              Add Followup
            </Button>
          </ModalFooter>
        </Modal>

        {this.state.modal && (
          <WorkOrderFollowUpForm
            model={this.state.model}
            modal={this.state.modal}
            alert={this.state.alert}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
          />
        )}
      </div>
    );
  }
}
